import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "mx-3 mx-lg-0 position-relative" }
const _hoisted_2 = { class: "row overflow-hidden tabs-wrapper" }
const _hoisted_3 = {
  class: "w-100 font-size-14 d-none d-lg-flex flex-row justify-content-between align-items-around",
  ref: "packagesContainer"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "tab-inner-wrapper" }
const _hoisted_6 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_7 = { class: "d-flex justify-content-center align-items-center pack-code" }
const _hoisted_8 = { class: "d-flex align-items-center" }

import { computed, onMounted } from "vue"
import { useStore } from "vuex"
import RadioCircle from "@/vue/common/radioCircle.vue"
import flightPackCode from "@/config/flightPackCode"
import trainPackCode from "@/config/trainPackCode"
import { Transport } from "@/types"

type SwitchOption = {
	label: string
	action: () => void
	selected: boolean
}

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'flightSwitch',
  props: {
	packagesToDisplay: {
		type: Array,
		default: () => [],
	},
},
  setup(__props) {

const props = __props

// Store
const store = useStore()

// Computed properties
const content = computed(() => store.state.content)
const selectedTransport = computed<Transport | null>(() => store.getters.transportv2)

// TODO will probably need to select a packCode here(transport or non)
const options = computed<SwitchOption[]>(() => {

	const isFlightEnabled = store.getters.availablePackCodes.some((pack: { codePackage: string }) => flightPackCode.includes(pack.codePackage)) 
	const isTrainEnabled = store.getters.availablePackCodes.some((pack: { codePackage: string }) => trainPackCode.includes(pack.codePackage))

	const options: SwitchOption[]=[];
	if (isFlightEnabled) {
		options.push(
		{
			label: content.value.transport_flight,
			action: () => handleSwitch(Transport.FLIGHT),
			selected: selectedTransport.value === Transport.FLIGHT
		});
	} 
	if (isTrainEnabled) {
		options.push({
			label: content.value.transport_train,
			action: () => handleSwitch(Transport.TRAIN),
			selected: selectedTransport.value === Transport.TRAIN
		});
	}
	options.push({
		label: content.value.transport_none,
		action: () => handleSwitch(null),
		selected: selectedTransport.value === null
	});

	return options
})

const tabWidth = computed(() => {
	return `${100 / (options.value.length || 1)}%`
})

const getDefaultPackCodeForTransport = (transport: Transport | null): string | undefined => {
	if (transport === Transport.FLIGHT) {
		return store.getters.availableFlightPackCodes[0]?.codePackage
	}
	if (transport === Transport.TRAIN) {
		return store.getters.availableTrainPackCodes[0]?.codePackage
	}
	const nonTransportPacks = store.getters.availableNonTransportPackCodes
	if (store.state.season === "E") {
		const seasonPacks = nonTransportPacks.filter(
			(pack: { codePackage: string }) =>
				pack.codePackage === "HS" || pack.codePackage === "PMA"
		)
		return seasonPacks[0]?.codePackage ?? nonTransportPacks[0]?.codePackage
	}
	return nonTransportPacks[0]?.codePackage
}

// Methods
// const selectTransport = (select: boolean): void => {
// 	store.dispatch("selectTransportWithDefaultPackage", select)
// }
const handleSwitch = async (transport: Transport | null) => {
	if (selectedTransport.value === transport) return

	const defaultPackCode = getDefaultPackCodeForTransport(transport)
	const shouldOpenParticipantsDropdown =
		store.getters.isLocaleEN &&
		(transport === Transport.FLIGHT || transport === Transport.TRAIN) &&
		store.state.participants.length > 9

	if (shouldOpenParticipantsDropdown) {
		store.commit("setParticipants", store.state.participants.slice(0, 9))
	}

	store.commit("setTransportv2", transport);
	store.commit("setTransportTrue", transport !== null);
	if (defaultPackCode) {
		await store.dispatch("setPackage", defaultPackCode)
	}
	// store.commit("setTransport", transport==='FLIGHT' || transport==='TRAIN')
	// store.commit("setTransportationSelected", transport==='FLIGHT' || transport==='TRAIN')
	// await store.dispatch("selectTransportWithDefaultPackage", transport==='FLIGHT' || transport==='TRAIN')


	if (transport===Transport.FLIGHT) {
		store.commit("setTransportationSelected", true)
		// Always select the first available origin when switching to a flight package tab
		await store.dispatch("selectDefaultFlightOrigin", { overwrite: true, forceFlightPackCode: true })
	} else if (transport===Transport.TRAIN) {
		store.commit("setTransportationSelected", true)
		// Always select the default train origin when switching to a train package tab
		await store.dispatch("selectDefaultTrainOrigin", { overwrite: true, forceTrainPackCode: true })
	} else {
		store.commit("setTransportationSelected", false)
		store.commit("setFlightOrigin", null)
	}

	if (shouldOpenParticipantsDropdown) {
		setTimeout(() => {
			store.dispatch("setParticipantsDropdownOpen", true)
		}, 0)
	}
	// Old stuff TO BE REMOVED
	// store.commit("setTransport", transport==='FLIGHT' || transport==='TRAIN')
	// store.commit("setTransportationSelected", transport==='FLIGHT' || transport==='TRAIN')
	// store.dispatch("setPackage", packagesToDisplay.value[0].codePackage)
	// store.dispatch("selectTransportWithDefaultPackage", transport==='FLIGHT' || transport==='TRAIN')
}


onMounted(() => {
	if (store.getters.transportv2 != null) return

	if (flightPackCode.includes(store.state.packCode)) {
		store.commit("setTransportv2", Transport.FLIGHT);
	} else if (trainPackCode.includes(store.state.packCode)) {
		store.commit("setTransportv2", Transport.TRAIN);
	}
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option, option_i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `${option}-${option_i}`,
            style: _normalizeStyle({ width: tabWidth.value }),
            class: _normalizeClass([
						option.selected
							? 'active font-weight-700'
							: 'text-grey-900'
					, "package-tab"]),
            onClick: option.action
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(RadioCircle, {
                  active: option.selected,
                  colorDefault: 'var(--primary-blue)',
                  colorActive: 'white',
                  additionalClasses: 'me-1 me-xl-3'
                }, null, 8, ["active"])
              ]),
              _createElementVNode("span", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(option.label), 1)
              ])
            ])
          ], 14, _hoisted_4))
        }), 128))
      ], 512)
    ])
  ]))
}
}

})